const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
import { createAnalyticsGroup } from 'js/lib/analytics'
import { registerFunctionalComponent } from 'js/lib/components/component'
import { useDynamicFrameLoading } from './dynamic_frame_loading.mjs'
import { updateButtonLoadingState } from './loading_state.mjs'

const setupObserver = (button) => {
  if (button.observer) return

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'data-loading') {
        updateButtonLoadingState(button)

        if (button.getAttribute('data-loading') === 'false') {
          observer.disconnect()
          button.observer = null
        }
      }
    })
  })

  observer.observe(button, { attributes: true })
  button.observer = observer
}

// Register general button functionality
registerFunctionalComponent('.js-c-ui-button', 'UiButtonComponent', (component) => {
  const button = component.element
  const handleClick = (event) => {
    const button = event.currentTarget
    if (button.getAttribute('data-loading') === 'true') {
      updateButtonLoadingState(button)
      setupObserver(button)
    }
  }

  component.useHandler(() => {
    button.addEventListener('click', handleClick)
    return () => button.removeEventListener('click', handleClick)
  })

  component.useHandler(() =>
    useDynamicFrameLoading(button, isLoading => {
      button.dataset.loading = isLoading ? 'true' : 'false'
      updateButtonLoadingState(button)
    })
  )
})

// Register tracking functionality for buttons with tracking attributes
registerFunctionalComponent('.js-c-ui-button-tracking', 'UiButtonTrackingComponent', (component) => {
  const trackingGroup = component.element.getAttribute('data-tracking-group')
  const trackingLabel = component.element.getAttribute('data-tracking-label')
  
  if (trackingGroup && trackingLabel) {
    const track = createAnalyticsGroup(trackingGroup)
    const currentPage = window.location.href
    
    component.useHandler(() => {
      const handleTrackingClick = () => {
        track('click', `${trackingLabel} from ${currentPage}`)
      }
      
      component.element.addEventListener('click', handleTrackingClick)
      return () => component.element.removeEventListener('click', handleTrackingClick)
    })
  }
})
